import {
    Container,
    Graphics,
    Text,
} from 'pixi.js';
import { SCREEN_HEIGHT, SCREEN_WIDTH, FONT_UI } from '../../GameConst';
import { CommonButton, ON_BUTTON_EVENT } from '../../components/CommonButton';

export class LayerNameBar extends Container {
    constructor(name, canBack){
        super();

        const leftPoxition = -20;

        const background = new Graphics().lineStyle(5, 0xFFFFFF, 1).beginFill(0x000000).drawRoundedRect(0, 0, SCREEN_WIDTH * 0.8, 100, 16);
        this.addChild(background);

        const backButtonHeight = background.height * 0.6;
        const backButtonWidth = backButtonHeight * 2;

        if(canBack){
            const object = new Graphics().beginFill(0xb1b1b1).drawRoundedRect(0, 0, backButtonWidth, backButtonHeight, 45);
            const backButton = new CommonButton(object);
            backButton.once(ON_BUTTON_EVENT, () => {
                this.parent.destroy({children:true});
            });

            const backButtonText = new Text('もどる', {
                fontFamily: FONT_UI,
                fontSize: 30,
                fill: 'black',
                fontWeight: 'bold',
            });
            backButtonText.anchor.set(0.5);
            object.addChild(backButtonText);

            backButtonText.x = backButtonWidth * 0.5;
            backButtonText.y = backButtonHeight * 0.5;

            backButton.x = -leftPoxition + backButton.width * 0.5;
            backButton.y = background.height * 0.5;
            this.addChild(backButton);
        }

        const nameText = new Text(name, {
            fontFamily: FONT_UI,
            fontSize: 40,
            fill: 'white',
            fontWeight: 'bold',
        });
        nameText.anchor.set(0, 0.5);
        nameText.x = 60 + (canBack ? backButtonWidth : 0);
        nameText.y = background.height * 0.5;
        this.addChild(nameText);

        this.x = leftPoxition;
        this.y = SCREEN_HEIGHT * 0.25;
    }
}
